export default "__VITE_ASSET__SiCOPUSl__"